<template>
  <div class="sla">
    <div class="head-box">
      <div class="c-flex c-flex-item">
        <p @click="$router.push({ path: '/SLAs' })" class="c-pointer">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </p>
        <el-divider direction="vertical"></el-divider>
        <span>SLA：{{ SLA.name }}</span>
      </div>
      <div class="c-flex c-flex-item">
        <el-button type="primary" @click="doSave('all')" class="c-m-l-10">
          保存
        </el-button>
      </div>
    </div>
    <div class="sla-content">
      <!-- SLA（全部节点） -->
      <div>
        <div class="title">{{ workflowDef.title }}SLA（全部节点）</div>
        <div class="preset-table">
          <el-table :data="SLA.presetSLAItems" :border="false">
            <el-table-column label="工作流节点" fixed min-width="180px">
              <template slot-scope="scope">
                <p class="node">
                  <icon-park type="dot" theme="outline" size="14" fill="#999" :strokeWidth="4" />
                  <span class="c_size_14">{{ formatName(scope.row.startNodeId) }}完成</span>
                </p>
                <icon-park
                  class="node-arrow"
                  v-if="scope.$index != SLA.presetSLAItems.length - 1"
                  type="arrow-down"
                  theme="outline"
                  size="14"
                  fill="#999"
                  :strokeWidth="4"
                />
              </template>
            </el-table-column>
            <!-- <el-table-column label="节点描述">
              <template slot-scope="scope">
                <div style="margin-bottom:40px;">{{ formatDesc(scope.row.startNodeId) }}</div>
              </template>
            </el-table-column> -->
            <el-table-column v-for="(level, index) in options.level" :key="index" min-width="170px">
              <template slot="header">
                <span class="c_m_r_5">{{ level.label }}</span>
                <!-- <el-tag type="success" effect="dark" size="mini">一般</el-tag> -->
              </template>
              <template slot-scope="scope" v-if="scope.$index != SLA.presetSLAItems.length - 1">
                <el-input
                  placeholder="请输入"
                  v-model="scope.row[`level${index + 1}Urgent`]"
                  class="time-type"
                >
                  <el-select
                    v-model="scope.row[`level${index + 1}TimeType`]"
                    style="width:85px;"
                    slot="append"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options.timeType"
                      :key="item.value"
                      :label="item.label"
                      :value="Number(item.value)"
                    ></el-option>
                  </el-select>
                </el-input>
              </template>
            </el-table-column>
            <!-- <el-table-column>
              <template slot="header">
                <span class="c_m_r_5">P3时效性</span>
                <el-tag type="success" effect="dark" size="mini">一般</el-tag>
              </template>
              <template slot-scope="scope" v-if="scope.$index != SLA.presetSLAItems.length - 1">
                <el-input placeholder="请输入" v-model="scope.row.level3Urgent" class="time-type">
                  <el-select
                    v-model="scope.row.level3TimeType"
                    style="width:90px;"
                    slot="append"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options.timeType"
                      :key="item.value"
                      :label="item.label"
                      :value="Number(item.value)"
                    ></el-option>
                  </el-select>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header">
                <span class="c_m_r_5">P2时效性</span>
                <el-tag type="warning" effect="dark" size="mini">紧急</el-tag>
              </template>
              <template slot-scope="scope" v-if="scope.$index != SLA.presetSLAItems.length - 1">
                <el-input placeholder="请输入" v-model="scope.row.level2Urgent" class="time-type">
                  <el-select
                    v-model="scope.row.level2TimeType"
                    style="width:90px;"
                    slot="append"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options.timeType"
                      :key="item.value"
                      :label="item.label"
                      :value="Number(item.value)"
                    ></el-option>
                  </el-select>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header">
                <span class="c_m_r_5">P1时效性</span>
                <el-tag type="danger" effect="dark" size="mini">非常紧急</el-tag>
              </template>
              <template slot-scope="scope" v-if="scope.$index != SLA.presetSLAItems.length - 1">
                <el-input placeholder="请输入" v-model="scope.row.level1Urgent" class="time-type">
                  <el-select
                    v-model="scope.row.level1TimeType"
                    style="width:90px;"
                    slot="append"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options.timeType"
                      :key="item.value"
                      :label="item.label"
                      :value="Number(item.value)"
                    ></el-option>
                  </el-select>
                </el-input>
              </template>
            </el-table-column> -->
            <el-table-column label="超时/预警提醒" min-width="170px">
              <template slot-scope="scope" v-if="scope.$index != SLA.presetSLAItems.length - 1">
                <el-button class="remind" @click="remindClick(scope.row)">
                  超时/预警提醒
                  <i
                    v-if="scope.row.correlationHandlers.length > 0"
                    class="el-icon-success el-icon--right c_green"
                  />
                  <i v-else class="el-icon-circle-plus el-icon--right c_blue" />
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- SLA（自定义节点） -->
      <div style="margin-top:40px;">
        <div class="title">{{ workflowDef.title }}SLA（自定义节点）</div>
        <div>
          <el-table :data="SLA.customizeSLAItems" :border="false">
            <el-table-column label="开始节点" fixed min-width="200px">
              <template slot-scope="scope">
                <div class="c-flex c_item_center">
                  <el-select v-model="scope.row.startNodeId" clearable placeholder="请选择节点">
                    <el-option
                      v-for="(item, i) in workflowDef.def.nodes"
                      :key="item.nodeId"
                      :label="item.name + '完成'"
                      :value="item.nodeId"
                      :disabled="
                        !scope.row.endNodeId
                          ? false
                          : i >= formatIndex(scope.row.endNodeId)
                          ? true
                          : false
                      "
                    ></el-option>
                  </el-select>
                  <icon-park
                    style="margin-left:20px;"
                    type="arrow-right"
                    theme="outline"
                    size="14"
                    fill="#999"
                    :strokeWidth="4"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column label="结束节点" fixed min-width="170px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.endNodeId" clearable placeholder="请选择节点">
                  <el-option
                    v-for="(item, i) in workflowDef.def.nodes"
                    :key="item.nodeId"
                    :label="item.name + '完成'"
                    :value="item.nodeId"
                    :disabled="
                      !scope.row.startNodeId
                        ? false
                        : i <= formatIndex(scope.row.startNodeId)
                        ? true
                        : false
                    "
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column v-for="(level, index) in options.level" :key="index" min-width="170px">
              <template slot="header">
                <span class="c_m_r_5">{{ level.label }}</span>
              </template>
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入"
                  v-model="scope.row[`level${index + 1}Urgent`]"
                  class="time-type m-t-0"
                >
                  <el-select
                    v-model="scope.row[`level${index + 1}TimeType`]"
                    style="width:90px;"
                    slot="append"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options.timeType"
                      :key="item.value"
                      :label="item.label"
                      :value="Number(item.value)"
                    ></el-option>
                  </el-select>
                </el-input>
              </template>
            </el-table-column>
            <!-- <el-table-column>
              <template slot="header">
                <span class="c_m_r_5">P3时效性</span>
                <el-tag type="success" effect="dark" size="mini">一般</el-tag>
              </template>
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入"
                  v-model="scope.row.level3Urgent"
                  class="time-type m-t-0"
                >
                  <el-select
                    v-model="scope.row.level3TimeType"
                    style="width:90px;"
                    slot="append"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options.timeType"
                      :key="item.value"
                      :label="item.label"
                      :value="Number(item.value)"
                    ></el-option>
                  </el-select>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header">
                <span class="c_m_r_5">P2时效性</span>
                <el-tag type="warning" effect="dark" size="mini">紧急</el-tag>
              </template>
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入"
                  v-model="scope.row.level2Urgent"
                  class="time-type m-t-0"
                >
                  <el-select
                    v-model="scope.row.level2TimeType"
                    style="width:90px;"
                    slot="append"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options.timeType"
                      :key="item.value"
                      :label="item.label"
                      :value="Number(item.value)"
                    ></el-option>
                  </el-select>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header">
                <span class="c_m_r_5">P1时效性</span>
                <el-tag type="danger" effect="dark" size="mini">非常紧急</el-tag>
              </template>
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入"
                  v-model="scope.row.level1Urgent"
                  class="time-type m-t-0"
                >
                  <el-select
                    v-model="scope.row.level1TimeType"
                    style="width:90px;"
                    slot="append"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options.timeType"
                      :key="item.value"
                      :label="item.label"
                      :value="Number(item.value)"
                    ></el-option>
                  </el-select>
                </el-input>
              </template>
            </el-table-column> -->
            <el-table-column label="超时/预警提醒" min-width="250px">
              <template slot-scope="scope">
                <el-button @click="remindClick(scope.row)">
                  超时/预警提醒
                  <i
                    v-if="scope.row.correlationHandlers.length > 0"
                    class="el-icon-success el-icon--right c_green"
                  />
                  <i v-else class="el-icon-circle-plus el-icon--right c_blue" />
                </el-button>
                <el-button plain type="danger" @click="removeCustomizeSLAItem(scope.$index)">
                  删除
                  <i class="el-icon-delete-solid el-icon--right" />
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" size="small" class="m-10" @click="addCustomizeSLAItem()">
            添加SLA
          </el-button>
        </div>
      </div>
    </div>
    <!-- 超时/预警提醒表单 -->
    <el-dialog
      title="超时/预警提醒"
      :visible.sync="openDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="formData" label-width="50px" label-position="left">
        <el-form-item>
          <div class="remind-decs">
            <p class="c-flex">
              <span style="width:40px;">公式：</span>
              <span>
                提醒时间 = 前一节点操作时间 + SLA规则配置的时效性 + 超时时间（- 预警时间）
              </span>
            </p>
            <p class="c-flex">
              <span style="width:112px;">公式：</span>
              <span>
                一笔非常紧急的工单创建时间为2021-01-01
                9:00，设置SLA受理阶段P1时效性1小时，并设置提醒超时半小时短信提醒主管，根据公式计算提醒时间：9:00+1:00+0:30=10:30，即在2021-01-01
                10:30还未完成受理，短信提醒主管。
              </span>
            </p>
          </div>
        </el-form-item>
        <el-form-item
          :label="'提醒' + (i + 1)"
          v-for="(item, i) in correlationHandlers"
          :key="i"
          style="position:relative;"
        >
          <el-card shadow="hover">
            <el-form-item label="时效性" label-width="80px" required>
              <el-select v-model="item.sign" style="width:50px;" placeholder="请选择">
                <el-option
                  v-for="item in options.sign"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提醒时间" label-width="80px" required>
              <el-select
                v-model="item.type"
                style="width:35% !important;margin-right:5%;"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options.remindType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>

              <el-input placeholder="请输入" v-model="item.count" style="width:60% !important;">
                <el-select
                  v-model="item.timeType"
                  style="width:90px;"
                  slot="append"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in options.timeType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item label="执行脚本" label-width="80px" required>
              <el-select v-model="item.groovyScriptId" style="width:50px;" placeholder="请选择">
                <el-option
                  v-for="item in options.groovyScripts"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-card>
          <i class="el-icon-remove c_red c_size_18 remove-icon" @click="removeRemind(i)"></i>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-plus" @click="addRemind">新增提醒</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave()">确 定</el-button>
        <el-button
          @click="
            openDialog = false;
            getSLADef(() => {
              getWorkflowDef();
            });
          "
        >
          取 消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'SLA',
  data() {
    window.$this = this;
    return {
      SLA: { presetSLAItems: [], customizeSLAItems: [] },
      workflowDef: {},
      options: {
        codecfg_timeType: { codeId: 'planTimeType' },
        sign: [
          { label: '全部等级', value: 'All' }
          // { label: 'P1 非常紧急', value: 'p1' },
          // { label: 'P2 紧急', value: 'p2' },
          // { label: 'P3 一般', value: 'p3' }
        ],
        remindType: [{ label: '预警', value: '1' }, { label: '超时', value: '2' }],
        groovyScripts: [],
        codecfg_level: { codeId: 'level' },
        level: []
      },
      openDialog: false,
      formData: {},
      correlationHandlers: []
    };
  },
  mounted() {
    this.osg.codeoption(() => {
      if (this.options.level && this.options.level.length > 0) {
        this.options.level.map(level => {
          this.options.sign.push({
            label: level.label,
            value: level.value
          });
        });
      } else {
        this.options.sign = this.options.sign.concat([
          { label: 'P1 非常紧急', value: 'p1' },
          { label: 'P2 紧急', value: 'p2' },
          { label: 'P3 一般', value: 'p3' }
        ]);
      }

      this.getSLADef(() => {
        this.getWorkflowDef();
        this.getGroovyScripts();
      });
    });
  },
  methods: {
    getSLADef(callback) {
      this.osg.ajax(
        'slaDef/findById.do',
        { id: this.osg.param('id') },
        res => {
          this.SLA = res.data;
          if (callback) callback();
        },
        { noload: true }
      );
    },
    getWorkflowDef() {
      this.osg.ajax(
        // `workflowDef/queryById/${this.SLA.workflowDefId}.do`,
        // {},
        'slaDef/queryNodeDef.do',
        { workflowDefId: this.SLA.workflowDefId },
        res => {
          this.workflowDef = res.entity || res.data || {};
          // 预置SLA数据
          for (let i = 0; i < this.workflowDef.def.nodes.length; i++) {
            let currentNode = this.workflowDef.def.nodes[i];
            let nextNode;
            if (i < this.workflowDef.def.nodes.length - 1)
              nextNode = this.workflowDef.def.nodes[i + 1];

            let SLAItem = this.SLA.presetSLAItems[i] || {};
            SLAItem.slaDefId = this.SLA._id;
            SLAItem.type = 0; //0:预置 1:自定义
            SLAItem.startNodeId = currentNode.nodeId; //定义节点id 从此节点结束开始
            if (i < this.workflowDef.def.nodes.length - 1) SLAItem.endNodeId = nextNode.nodeId; //定义节点id 到此节点结束
            for (let index = 0; index < this.options.level.length; index++) {
              SLAItem[`level${index + 1}Urgent`] = SLAItem[`level${index + 1}Urgent`] || 0; //非常紧急时效 0:无
              SLAItem[`level${index + 1}TimeType`] = SLAItem[`level${index + 1}TimeType`] || 1; //时间类型 1:分钟
            }
            // SLAItem.level1Urgent = SLAItem.level1Urgent || 0; //非常紧急时效 0:无
            // SLAItem.level1TimeType = SLAItem.level1TimeType || 1; //时间类型 1:分钟
            // SLAItem.level2Urgent = SLAItem.level2Urgent || 0; //非常紧急时效 0:无
            // SLAItem.level2TimeType = SLAItem.level2TimeType || 1; //时间类型 1:分钟
            // SLAItem.level3Urgent = SLAItem.level3Urgent || 0; //非常紧急时效 0:无
            // SLAItem.level3TimeType = SLAItem.level3TimeType || 1; //时间类型 1:分钟

            SLAItem.correlationHandlers = SLAItem.correlationHandlers || []; //超时/预警提醒
            this.$set(this.SLA.presetSLAItems, i, SLAItem);
          }
          // 自定义SLA数据
          if (this.SLA.customizeSLAItems.length == 0) {
            let obj = {
              slaDefId: this.SLA._id,
              type: 1, //0:预置 1:自定义
              startNodeId: this.workflowDef.def.nodes[0].nodeId, //定义节点id 从此节点结束开始
              endNodeId: this.workflowDef.def.nodes[this.workflowDef.def.nodes.length - 1].nodeId, //定义节点id 到此节点结束
              // level1Urgent: 0, //非常紧急时效 0:无
              // level1TimeType: 1, //时间类型 1:分钟
              // level2Urgent: 0, //非常紧急时效 0:无
              // level2TimeType: 1, //时间类型 1:分钟
              // level3Urgent: 0, //非常紧急时效 0:无
              // level3TimeType: 1, //时间类型 1:分钟
              correlationHandlers: [] //超时/预警提醒
            };
            for (let index = 0; index < this.options.level.length; index++) {
              obj[`level${index + 1}Urgent`] = 0; //非常紧急时效 0:无
              obj[`level${index + 1}TimeType`] = 1; //时间类型 1:分钟
            }
            this.SLA.customizeSLAItems.push(obj);
          }
        },
        { noload: true }
      );
    },
    getGroovyScripts() {
      this.osg.ajax(
        'groovyScript/query.do',
        { _all: 1, 'is:type|integer#and': 6, 'is:state|integer#and': 1 },
        res => {
          this.options.groovyScripts = res.data;
        }
      );
    },
    remindClick(item) {
      this.correlationHandlers = item.correlationHandlers;
      if (this.correlationHandlers.length == 0)
        this.correlationHandlers.push({ sign: 'All', type: '1', timeType: '1' });
      this.openDialog = true;
    },
    addRemind() {
      this.correlationHandlers.push({
        sign: 'All',
        type: '1',
        timeType: '1'
      });
    },
    removeRemind(index) {
      this.correlationHandlers.splice(index, 1);
    },
    addCustomizeSLAItem() {
      let obj = {
        slaDefId: this.SLA._id,
        type: 1, //0:预置 1:自定义
        startNodeId: '', //定义节点id 从此节点结束开始
        endNodeId: '', //定义节点id 到此节点结束
        level1Urgent: 0, //非常紧急时效 0:无
        level1TimeType: 1, //时间类型 1:分钟
        level2Urgent: 0, //非常紧急时效 0:无
        level2TimeType: 1, //时间类型 1:分钟
        level3Urgent: 0, //非常紧急时效 0:无
        level3TimeType: 1, //时间类型 1:分钟
        correlationHandlers: [] //超时/预警提醒
      };
      for (let index = 0; index < this.options.level.length; index++) {
        obj[`level${index + 1}Urgent`] = 0; //非常紧急时效 0:无
        obj[`level${index + 1}TimeType`] = 1; //时间类型 1:分钟
      }
      this.SLA.customizeSLAItems.push(obj);
    },
    removeCustomizeSLAItem(index) {
      this.osg.confirm('是否确认删除？', () => {
        this.SLA.customizeSLAItems.splice(index, 1);
      });
    },
    doSave(type) {
      if (type != 'all') {
        for (let remind of this.correlationHandlers) {
          if (!remind.count && remind.count !== 0) {
            this.osg.toast('请输入提醒时间', 'warning');
            return;
          }
          if (!remind.groovyScriptId) {
            this.osg.toast('请选择执行脚本', 'warning');
            return;
          }
        }
      }
      this.osg.ajax('slaDef/upsert.do', { data: JSON.stringify(this.SLA) }, () => {
        this.osg.toast('保存成功');
        this.openDialog = false;
        this.getSLADef();
      });
    },
    formatName(nodeId) {
      if (!this.workflowDef.def) return;
      for (let node of this.workflowDef.def.nodes) {
        if (nodeId == node.nodeId) {
          return node.name;
        }
      }
    },
    formatDesc(nodeId) {
      if (!this.workflowDef.def) return;
      for (let node of this.workflowDef.def.nodes) {
        if (nodeId == node.nodeId) {
          return node.desc;
        }
      }
    },
    formatIndex(nodeId) {
      if (!this.workflowDef.def) return;
      for (let i = 0; i < this.workflowDef.def.nodes.length; i++) {
        if (nodeId == this.workflowDef.def.nodes[i].nodeId) {
          return i;
        }
      }
    }
  }
};
</script>
<style scoped lang="scss">
.sla {
  .sla-content {
    flex: 1;
    overflow: auto;
    .title {
      padding: 10px;
    }
    ::v-deep .el-table {
      .el-table__header {
        th {
          background-color: #f8f8f9;
        }
      }
      .node {
        display: flex;
        align-items: center;
        border: 1px solid #e9eaec;
        width: fit-content;
        border-radius: 3px;
        padding: 5px 15px 5px 5px;
        span {
          margin-left: 5px;
        }
      }
      .node-arrow {
        margin: 20px 44px 0;
      }
      .time-type {
        width: 150px;
        margin-top: 40px;
      }
      .remind {
        margin-top: 40px;
      }
    }
    .preset-table {
      ::v-deep .el-table {
        tbody {
          tr {
            td {
              border-bottom: none !important;
            }
            &:hover td {
              background-color: #fff;
            }
          }
        }
      }
    }
  }
  .remind-decs {
    font-size: 10px;
    line-height: 20px;
    border: 1px solid #e6a23c;
    border-radius: 4px;
    padding: 5px 10px;
    box-sizing: border-box;
  }
  .remove-icon {
    position: absolute;
    right: -30px;
    top: 5px;
    cursor: pointer;
  }
}
</style>
